$(function () {
    'use strict';

    var showedNumber = 0;
    var showed = {};
    var clicked = {};

    $(document).on('MarketplacePromotion::GetByPhoto', function (event, context, photoId, params, callback) {
        showedNumber++;
        var data = params ? params : {};
        data['photo_id'] = photoId;
        data['number'] = showedNumber;

        $.ajax({
           url: '/market/photo_overlay_promotion/',
           data: data,
           dataType: 'json',
           type: 'POST'
       })
            .done(function(result){
                callback(context, result);
            })
            .fail(function(){

            });
    });

    var markAdAsShowed = function($ad) {
        var adId = $ad.data('promoId');
        showed[adId] = true;
        sendToEcommerce($ad, 'show');

    };

    var markAdAsClicked = function($ad) {
        var adId = $ad.data('promoId');
        clicked[adId] = true;
        sendToEcommerce($ad, 'click');
    };

    var sendToEcommerce = function($ad, action) {
        var adId = $ad.data('promoId');

        var promoName = 'Marketplace crosspromo';
        var promoId = promoName;
        var position = undefined;
        if ($ad.data('promoPosition')) {
            position = $ad.data('promoPosition');
        }

        if (typeof window.Tracker != 'undefined') {
            if (action == 'show') {
                window.Tracker.ecommerceShowPromo(promoId, promoName, adId, position)
            } else if (action == 'click') {
                window.Tracker.ecommerceClickPromo(promoId, promoName, adId, position);
            }
        }
    };

    var $listingPromotion = $('.marketplace-promotion');
    var overlayPromotionSelector = '.marketplace-promotion-overlay';
    if ($listingPromotion.length) {
        $(window).on('resize.MarketplacePromotionShow scroll.MarketplacePromotionShow', function() {
            $listingPromotion.each(function(){
                var $promotion = $(this);
                if ($promotion.isOnScreen()) {
                    var adId = $promotion.data('promoId');
                    if (typeof showed[adId] == 'undefined') {
                        markAdAsShowed($promotion);

                        var showedCount = Object.keys(showed).length;

                        if (showedCount == $listingPromotion.length) {
                            $(window).off('.MarketplacePromotionShow');
                        }
                    }
                }
            });

        });

        $listingPromotion.on('click', function(e) {
            var $ad = $(this);
            var adId = $ad.data('promoId');
            if (typeof clicked[adId] == 'undefined') {
                markAdAsClicked($ad);
            }
        });
    }
});